import React, { useState } from "react";
import { FaLock, FaUserMd, FaClipboardList, FaMinus, FaPlus, FaShieldAlt, FaSyncAlt, FaDatabase, FaUserCheck, FaLaptopMedical, FaChartLine, FaChartPie, FaHeartbeat, FaUserNurse, FaCode, FaCloudUploadAlt, FaFileSignature, FaBell, FaHandHoldingUsd, FaHospitalUser } from "react-icons/fa";
import Medpalm from "../../../assests/Healthsoftware/ElectronicHealth.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
import { AiOutlineDeploymentUnit, AiOutlineInteraction, AiOutlineLock, AiOutlineTeam, AiOutlineUser } from "react-icons/ai";
import { MdAccessTime, MdCloudUpload, MdDescription, MdNotifications, MdSync } from "react-icons/md";
const services = [
    {
      "title": "EHR Implementation & Integration",
      "description": "We provide expert Electronic Health Record (EHR) implementation and integration services, ensuring your systems are tailored to meet your healthcare organization's specific needs while improving data management and accessibility."
    },
    {
      "title": "Data Migration & Conversion",
      "description": "Our team helps healthcare organizations migrate from legacy systems to modern CHR solutions, ensuring seamless data conversion and safeguarding patient information integrity throughout the process."
    },
    {
      "title": "Interoperability Solutions",
      "description": "We specialize in providing interoperability solutions that enable seamless data exchange between clinical, provider, patient, and payer systems, enhancing communication and ensuring better care coordination."
    },
    {
      "title": "Compliance & Security Audits",
      "description": "We conduct comprehensive compliance and security audits to ensure your CHR system adheres to industry standards like HIPAA, GDPR, and other regulations, safeguarding patient data and ensuring regulatory adherence."
    },
    {
      "title": "Customization & Workflow Optimization",
      "description": "We customize and optimize workflows to suit your healthcare organization’s unique needs, improving efficiency, reducing redundancy, and enhancing user experience."
    },
    {
      "title": "Training & Support",
      "description": "We offer thorough training and ongoing support for healthcare teams, ensuring they are equipped to fully utilize your new CHR system and maintaining optimal system performance."
    }
  ]
  
const features = [
    { icon: <MdDescription className="text-[#2a627a] text-lg" />, text: "Comprehensive Patient Health Records - Integrate patient data from various sources (e.g., clinical, laboratory, imaging) into a single digital record for easy access and better patient care." },
    { icon: <MdSync className="text-[#2a627a] text-lg" />, text: "Interoperability Across Systems - We ensure your CHR integrates seamlessly with other clinical, provider, and payer systems, ensuring smooth data exchange and communication." },
    // { icon: <FaLock className="text-[#2a627a] text-lg" />, text: "HIPAA-compliant security measures to protect patient data." },
    { icon: <MdCloudUpload className="text-[#2a627a] text-lg" />, text: "Cloud-Based Solutions- Our CHR systems are hosted in the cloud, offering scalability, secure access, and easy updates across different healthcare facilities." },
    { icon: <MdAccessTime className="text-[#2a627a] text-lg" />, text: " Real-Time Data Access- Healthcare providers can access up-to-date patient information from anywhere, improving response times and treatment efficiency." },
    { icon: <MdNotifications className="text-[#2a627a] text-lg" />, text: " Automation of Administrative Tasks- Automate patient scheduling, billing, coding, and reporting, saving time and reducing administrative overhead." }
  ];
const benefits = [
    { icon: <FaChartLine className="text-[#2a627a] text-lg" />, text: "CHRs provide accurate, comprehensive, and up-to-date information that supports informed clinical decisions and better patient outcomes" },
    { icon: <FaHeartbeat className="text-[#2a627a] text-lg" />, text: "With streamlined data sharing across departments and organizations, healthcare teams can collaborate more effectively, leading to better care coordination" },
    { icon: <FaUserCheck className="text-[#2a627a] text-lg" />, text: "Automating administrative processes and eliminating paper records improve workflow efficiency and reduce operational costs." },
    { icon: <FaHandHoldingUsd className="text-[#2a627a] text-lg" />, text: "Our CHR systems ensure compliance with industry standards like HIPAA, GDPR, and other healthcare regulations, safeguarding patient privacy." },
    { icon: <FaHospitalUser className="text-[#2a627a] text-lg" />, text: "By enabling better tracking of medical histories, treatments, and prescriptions, CHRs ensure comprehensive patient care, leading to improved health outcomes." },
    // { icon: <FaChartPie className="text-[#2a627a] text-lg" />, text: "Enables data-driven decision-making for better patient outcomes." }
  ]
const consentItems = [
    { icon: <AiOutlineUser className="text-[#2a627a] text-lg" />, text: "Improved Patient Management –CHRs allow healthcare providers to manage patient health information efficiently, improving decision-making and patient outcomes." },
    { icon: <AiOutlineTeam className="text-[#2a627a] text-lg" />, text: "Enhanced Communication Across Providers – CHRs ensure seamless communication between clinical teams, ensuring that all relevant patient information is shared and accessible." },
    { icon: <AiOutlineLock className="text-[#2a627a] text-lg" />, text: "Better Data Security – Our CHR solutions ensure the protection of patient data with encryption, secure access, and compliance with HIPAA and other regulations." },
    { icon: <AiOutlineDeploymentUnit className="text-[#2a627a] text-lg" />, text: "Streamlined Workflow & Efficiency –CHRs improve administrative workflows, reduce paperwork, and allow healthcare providers to focus more on patient care rather than administrative tasks." },
    { icon: <AiOutlineInteraction className="text-[#2a627a] text-lg" />, text: "Better Patient Engagement – With integrated patient portals, CHRs enable patients to access their health information, improving engagement and compliance with treatment plans." },
    // { icon: <FaDatabase className="text-[#2a627a] text-lg" />, text: "Data Analyst – Utilizes EHR data for reporting, analytics, and performance improvement." }
  ];

const EHR = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 ">Clinical Health Records (CHR)   </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                    "Securely manage patient data with seamless, interoperable, and HIPAA-compliant EHR solutions".
                    </p>
                </div>

                {/* What is Consent? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-2xl hover:shadow-2xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]">What is an Clinical Health Records?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                        Clinical Health Records (CHR) refer to a digital version of patients' paper charts, including medical history, diagnoses, treatment plans, and lab results. CHR systems provide real-time, patient-centered records that make information available instantly and securely to authorized users. Our services focus on enhancing the functionality, security, and integration of clinical systems, improving healthcare operations and patient care.


                        </p>
                    </div>
                </section>

                {/* Role of Patient Flow Management*/}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 ">
                        Role of Clinical Health Records
                    </h2>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {consentItems.map((item, index) => (
                            <motion.div
                                key={index}
                                className="relative z-10 bg-gray-300 bg-opacity-70 hover:bg-gray-300 text-gray-800 p-6 rounded-xl shadow-lg transition-transform transform hover:scale-105 hover:shadow-2xl"
                                initial={{ opacity: 0, x: -100 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1 }}
                            >
                                <span className="text-[#2a627a] text-lg">{item.icon}</span>
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 ">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="relative bg-gray-300 bg-opacity-70 hover:bg-gray-300 text-gray-800 p-6 rounded-xl shadow-lg transition-transform transform hover:scale-105 hover:shadow-2xl flex flex-col items-center text-center"
                                initial={{ opacity: 0, x: 20 }}
                                whileInView={{ opacity: 1, x: -10 }}
                                transition={{ duration: 1 }}
                            // viewport={{ once: true }}
                            >
                               <span className="text-sm">{item.icon}</span>
                                <span className="text-gray-800 text-sm font-medium mt-3">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-bg-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>
                               <span className="text-sm">{item.icon}</span>
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-bg-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default EHR;
